import BigNumber from './layout/bigNumber';
import Fact from './layout/fact';
import Wrapper from './layout/wrapper';
import React from 'react';
import car from 'img/car.svg';
import home from 'img/home.svg';

const formatNumber = value => Number(value || 0).toLocaleString('es-ES', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const Energetic_Demand = ({ amount, cars, homeValue, kpiDict, año }) => {
  const targetYear = kpiDict.demanda_energia_target_year || año;
  const topSectors = kpiDict.demanda_energia_top_sectores || [];

  return (
    <Wrapper>
      <Fact>
        <h4>
          Reducción de consumo de energía con respecto a Escenario Base para el año {año}
        </h4>
        <BigNumber>
          <h1 style={{ marginTop: 80 }}>
            {formatNumber(Math.floor(amount))}
          </h1>
          <label>
            TCal
          </label>
        </BigNumber>
      </Fact>
      <div>
        <Fact>
          <Wrapper>
            <div style={{ width: 240 }}>
              <img src={home} width={80} alt="home" />
            </div>
            <p style={{ paddingTop: 20 }}>
              Esta reducción equivale al consumo de energía eléctrica de <b>{formatNumber(Math.floor(homeValue))}</b> hogares chilenos en un año
            </p>
          </Wrapper>
        </Fact>
        <Fact>
          <Wrapper>
            <div style={{ width: 190 }}>
              <img src={car} width={80} alt="car" />
            </div>
            <p style={{ paddingTop: 20 }}>
              Esta reducción equivale al consumo promedio anual de <b>{formatNumber(Math.ceil(Number(cars)))}</b> automóviles
            </p>
          </Wrapper>
        </Fact>
        <Fact>
          <h4>
            Sectores con mayor demanda de energía en {targetYear}
          </h4>
          <BigNumber>
            {topSectors.map((sector, index) => (
              <h4 key={sector.label}>
                {index + 1}. {sector.label}: {formatNumber(sector.value)} TCal
              </h4>
            ))}
          </BigNumber>
        </Fact>
      </div>
    </Wrapper>
  );
};

export default Energetic_Demand;
